<template>
  <v-card-item>
    <!-- start title -->
    <template slot="title">
      {{ campsiteBooking.campgroundName }} - {{ campsiteBooking.campsiteNumber }} {{ campsiteBooking.campsiteName }}
      <CampsiteIcons
        :campsite="campsiteBooking"
        class="pl-4"
      />
    </template>
    <!-- end title -->
    <template slot="actions">
      <slot name="actions"/>
    </template>
    <!-- start content -->
    <template>
      <v-layout row>
        <v-flex xs8>
          <strong>Date:</strong> {{ campsiteBooking.date }}<br>
        </v-flex>
        <v-flex>
          <strong>Price:</strong> ${{ campsiteBooking.retailPrice }}
        </v-flex>
      </v-layout>
      <p v-if="showDetails">
        <strong>Type:</strong> {{ campsiteBooking.campsiteTypeWord }}<br>
        <template v-if="showDetails && campsiteBooking.campsiteDetails">
          <strong>Details:</strong> {{ campsiteBooking.campsiteDetails }}
        </template>
      </p>
      <slot/>
    </template>
    <!-- end content -->
  </v-card-item>
</template>

<script>
export default {
  props: {
    campsiteBooking: {
      type: Object,
      default: function () { return {} }
    },
    showDetails: {
      type: Boolean,
      default: false
    }
  }
}
</script>
